import { CONSTANTS } from './constants';

// Calculates an offset to use to set scroll position so that the card
// container centers a card (or 2 cards if width allows) for mobile sizes
export const getCardOffset = (windowWidth: number) => {
  const mobileCardWidth = CONSTANTS.imageDimensions.base.width;
  const cardGap = parseFloat(CONSTANTS.cardGap);

  let halfOffset = 0;

  // for when window is wide enough to allow 2 cards to be centered
  if (windowWidth > mobileCardWidth * 3 + cardGap * 3) {
    halfOffset = (windowWidth - mobileCardWidth * 2 - cardGap * 3) / 2;
  } else {
    // for when window allows for 1 card to be centered
    halfOffset = (windowWidth - mobileCardWidth - cardGap * 2) / 2;
  }

  return mobileCardWidth - halfOffset;
};
